import { createContext } from 'react'

export const FirmReportExportContext = createContext({})
